import {Record as record} from 'immutable';
import _ from 'lodash';
import moment from 'moment';

import { resolve } from '../../helpers/LinkMapper';

const defaults = {
    customerId: null,
    customerName: null,
    email: null,
    associatedSmartcardNumber: null,
    associatedSmartcardStatus: null,
    isAdult: false,
    isMain: false,
    associationId: null,
    associationStatus: null,
    cardHolderDateOfBirth: null,
    expiryDate: null,
    isNewCardRequestConfirmed: false,
};

class SmartcardAssociationInfo extends record(defaults) {
    static fromJSON(json = {}) {
        return new SmartcardAssociationInfo({
            customerId: resolve(json.customerId).with(Number),
            customerName: resolve(json.customerName).with(String),
            email: resolve(json.email).with(String),
            associatedSmartcardNumber: resolve(json.linkedSmartcardNumber).with(String),
            associatedSmartcardStatus: resolve(json.linkedSmartcardStatus).with(String),
            isAdult: resolve(json.isAdult).with(Boolean),
            isMain: resolve(json.isMain).with(Boolean),
            associationId: resolve(json.linkId).with(Number),
            associationStatus: resolve(json.linkStatus).with(String),
            cardHolderDateOfBirth: resolve(json.cardHolderDateOfBirth).with(String),
            expiryDate: resolve(json.expiryDate).with(String),
            isNewCardRequestConfirmed: resolve(json.isNewCardRequestConfirmed).with(Boolean),
        });
    }

    getCardNumber() {
        const {associatedSmartcardNumber} = this;
        const re = /(\d{6})(\d{4})(\d{4})(\d{4})/;
        const match = associatedSmartcardNumber && associatedSmartcardNumber.match(re);
        if (match) {
            return _.tail(match).join('-');
        }
        return null;
    }

    getCustomerName() {
        return this.customerName;
    }

    getCardHolderDateOfBirthMoment() {
        return this.cardHolderDateOfBirth ? moment(this.cardHolderDateOfBirth) : null;
    }

    getExpiryDateMoment() {
        return this.expiryDate ? moment(this.expiryDate) : null;
    }
}

export default SmartcardAssociationInfo;
